import React from 'react'
import AllDiscountProductContainer from '../../../../../Components/DiscountPart/CreateDiscountContainer/AllDiscountProductContainer/AllDiscountProductContainer'
import Layout from '../../../Layout'

const AllDiscountProduct = () => {
  return (
    <Layout><AllDiscountProductContainer/></Layout>
  )
}

export default AllDiscountProduct